import { render, staticRenderFns } from "./UiShowWithdraw.vue?vue&type=template&id=307a074b&lang=pug&"
import script from "./UiShowWithdraw.vue?vue&type=script&lang=js&"
export * from "./UiShowWithdraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports